var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}; // Export Specific Theme tokens


import { DEFAULT_THEME } from './default';
import { get, camelCase } from 'lodash';
import * as polished from 'polished';
import { BIO_THEME } from './bio';
import { BLAZE_THEME } from './blaze';
import { HEART_THEME } from './heart';
import { JUSTICE_THEME } from './justice';
import { LEARN_THEME } from './learn';
import { OCEAN_THEME } from './ocean';
import { SPORT_THEME } from './sport';
import { TRIBE_THEME } from './tribe';
import { OC_THEME } from './oc';
import { VILLARS_THEME } from './villars';
import { LAB_THEME } from './lab';
import { WEB_THEME } from './web';
import { css } from 'styled-components';
import { map, omit, first, compact } from 'lodash';
export * from './default';
export var minWidth = {
  base: 320,
  phone: 400,
  landscape: 500,
  tablet: 768,
  desktop: 1024,
  maxContent: 1435,
  maxContentPad: 1465,
  desktopMid: 1280,
  desktopLarge: 1440,
  desktopFullHD: 1920,
  desktop4Column: 1940,
  desktop5Column: 2260,
  desktop6Column: 2500
};
export var to = Object.keys(minWidth).reduce(function (acc, label) {
  acc[label] = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (max-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media (max-width: ", "px) {\n      ", "\n    }\n  "])), minWidth[label] - 1, css.apply(null, args || []));
  };

  return acc; // tslint:disable-next-line
}, {});
export var from = Object.keys(minWidth).reduce(function (acc, label) {
  acc[label] = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @media (min-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media (min-width: ", "px) {\n      ", "\n    }\n  "])), minWidth[label], css.apply(null, args || []));
  };

  return acc; // tslint:disable-next-line
}, {});
export var breakpoints = function breakpoints(styles) {
  var without = omit(styles, ['base', 'last', 'extra']);
  var others = map(without, function (props, key) {
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), from[key](templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), props));
  });
  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), styles.base, others, styles.last, styles.extra);
};
export var EXTRA_CSS = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), function (_a) {
  var _b = _a.extraStyles,
      extraStyles = _b === void 0 ? '' : _b;
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), extraStyles);
});
export var JustifyToAlign = {
  start: 'left',
  end: 'right',
  center: 'center'
};
export var grid = function grid(props, value, plus) {
  return value * get(props, 'theme.grid.unit', DEFAULT_THEME.grid.unit) + (plus || 0) + "px";
};
export var gridSize = function gridSize(props, type, size, breakpoint, cssUnit) {
  if (cssUnit === void 0) {
    cssUnit = 'px';
  }

  var multiplier = get(props, "theme.grid." + type + "." + camelCase(size) + "." + camelCase(breakpoint), 4);
  var unit = get(props, 'theme.grid.unit', DEFAULT_THEME.grid.unit);
  return "" + multiplier * unit + cssUnit;
};
/*
Color functions attempt to find a color at the specified key in the theme object from props,
(provided by a styled components ThemeProvider). If this is not found, we assume we have just been
given a standard CSS color string.
*/

export var color = function color(props, key, fallbackKey) {
  // if there are any dots, assume this is a full path (already camelCased but with sub properties) 
  if (!key) {
    // console.warn("Color function was passed an undefined key, using black.");
    return '#000';
  }

  var colorKey = key.match(/\./ig) ? key : camelCase(key);
  var fallbackColorKey = fallbackKey && (fallbackKey.match(/\./ig) ? fallbackKey : camelCase(fallbackKey)) || '';
  return get(props, "theme.color." + colorKey, get(props, "theme.color." + fallbackColorKey, key));
};
/*
Color functions attempt to find a color at the specified key in the theme object from props,
(provided by a styled components ThemeProvider). If this is not found, we assume we have just been
given a standard CSS color string.
*/

export var bg = function bg(props, key) {
  if (!key) {
    // console.warn("bg function was passed an undefined key, using black.");
    return '#000';
  } // if there are any dots, assume this is a full path (already camelCased but with sub properties) 


  var colorKey = key.match(/\./ig) ? key : camelCase(key);
  return get(props, "theme.background." + colorKey, key);
};
export var fill = function fill(props, key, fallbackKey) {
  return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    path, rect, circle, polygon {\n      fill: ", ";\n    }\n  "], ["\n    path, rect, circle, polygon {\n      fill: ", ";\n    }\n  "])), color(props, key, fallbackKey));
};
export var fills = function fills(props) {
  var keys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    keys[_i - 1] = arguments[_i];
  }

  return fill(props, colors.apply(void 0, __spreadArray([props], keys, false)));
};
export var colors = function colors(props) {
  var keys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    keys[_i - 1] = arguments[_i];
  }

  var validKeys = compact(keys); // console.log("VALID KEYS", validKeys);

  var themeColorToUse = validKeys.find(function (key) {
    return !!get(props, "theme.color." + camelCase(key));
  });

  if (!themeColorToUse) {
    return first(validKeys) || '#000000';
  } // console.log("THEME COLOR TO USE", themeColorToUse);


  return get(props, "theme.color." + camelCase(themeColorToUse), themeColorToUse);
};
export var dotBG = function dotBG(props, direction, colorKey, size, distance) {
  if (direction === void 0) {
    direction = 'h';
  }

  if (colorKey === void 0) {
    colorKey = 'line';
  }

  if (size === void 0) {
    size = 2;
  }

  if (distance === void 0) {
    distance = 6;
  }

  var radius = size / 2;
  var colorValue = color(props, colorKey);
  var fill = colorValue.replace('#', '%23');
  var viewBoxBound = direction === 'v' ? size + " " + distance : distance + " " + size;
  var backgroundRepeat = direction === 'both' ? 'repeat' : direction === 'v' ? 'repeat-y' : 'repeat-x';
  var backgroundSize = direction === 'v' ? size + "px " + distance + "px" : distance + "px " + size + "px";
  return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' viewbox='0 0 ", "'><circle r='", "' cx='", "' cy='", "' fill='", "'></circle></svg>\");\n    background-repeat: ", ";\n    background-size: ", ";\n  "], ["\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' viewbox='0 0 ", "'><circle r='", "' cx='", "' cy='", "' fill='", "'></circle></svg>\");\n    background-repeat: ", ";\n    background-size: ", ";\n  "])), viewBoxBound, radius, radius, radius, fill, backgroundRepeat, backgroundSize);
};
export var prop = function prop(props, key, unit) {
  if (unit === void 0) {
    unit = '';
  }

  return "" + get(props, "theme." + key, '') + unit;
};
export var fontFamily = function fontFamily(props, key) {
  return get(props, "theme.font.family." + key, key);
};
/* Wrappers for `polished` manipulations, for more concise consumers */

export var lighten = function lighten(props, key, by) {
  if (by === void 0) {
    by = 0.1;
  }

  return polished.lighten(by, color(props, key));
};
/* Wrappers for `polished` manipulations, for more concise consumers */

export var bgLighten = function bgLighten(props, key, by) {
  if (by === void 0) {
    by = 0.1;
  }

  return polished.lighten(by, bg(props, key));
};
export var darken = function darken(props, key, by) {
  if (by === void 0) {
    by = 0.1;
  }

  return polished.darken(by, color(props, key));
};
export var rem = function rem(props, size) {
  return size / get(props, "theme.fonts.size.base", 16) + "rem";
};
/* ---- Ready made prop function creators, which allow for simpler declarations ---- */

/**
 * Generates an SVG background of a line of dots (or grid of dots, if direction is both)
 *
 * @param direction The direction of the line, or use 'both' to create a grid
 * @param colorKey The symbolc color name (taken from the theme)
 * @param size The width/height of each dot
 * @param distance The distance between the centers of each dot
 */

export var DOT_BG = function DOT_BG(direction, colorKey, size, distance) {
  if (direction === void 0) {
    direction = 'h';
  }

  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }

  if (size === void 0) {
    size = 2;
  }

  if (distance === void 0) {
    distance = 4;
  }

  return function (props) {
    return dotBG(props, direction, colorKey, size, distance);
  };
};
export var H_DOT_BG = function H_DOT_BG(colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }

  if (size === void 0) {
    size = 2;
  }

  if (distance === void 0) {
    distance = 4;
  }

  return function (props) {
    return dotBG(props, 'h', colorKey, size, distance);
  };
};
export var V_DOT_BG = function V_DOT_BG(colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }

  if (size === void 0) {
    size = 2;
  }

  if (distance === void 0) {
    distance = 4;
  }

  return function (props) {
    return dotBG(props, 'v', colorKey, size, distance);
  };
};
export var H_DOT_BG_END = function H_DOT_BG_END(colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }

  if (size === void 0) {
    size = 2;
  }

  if (distance === void 0) {
    distance = 4;
  }

  return function (props) {
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  background-position: bottom left;\n"], ["\n  ", ";\n  background-position: bottom left;\n"])), dotBG(props, 'h', colorKey, size, distance));
  };
};
export var V_DOT_BG_END = function V_DOT_BG_END(colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }

  if (size === void 0) {
    size = 2;
  }

  if (distance === void 0) {
    distance = 4;
  }

  return function (props) {
    return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n  background-position: top right;\n"], ["\n  ", ";\n  background-position: top right;\n"])), dotBG(props, 'v', colorKey, size, distance));
  };
};
/**
 * Creates a prop function to provide a font-family for a given symbolic name (specified in the theme)
 * @param key the symbolic variant name for the font family. e.g. 'heading', 'sans', etc
 */

export var FONT = function FONT(key) {
  return function (props) {
    return fontFamily(props, key);
  };
};
/**
 * Creates a prop function to compute the correct rem value for a given size
 * @param size The final intended point size
 */

export var FONT_SIZE = function FONT_SIZE(size) {
  return function (props) {
    return rem(props, size);
  };
};
/**
 * Creates a prop function to compute rem value for a named breakpoint (taken from the theme)
 * @param breakpoint the name of the breakpoint to use
 * @param variant the size variant for breakpoint size (allows multiple sets of responsive sizes)
 */

export var FONT_SIZE_FOR = function FONT_SIZE_FOR(breakpoint, variant) {
  if (variant === void 0) {
    variant = 'normal';
  }

  return function (props) {
    return rem(props, parseInt(prop(props, "font.size." + camelCase(variant) + "." + camelCase(breakpoint)), 10));
  };
};
/**
 * Creates a prop function to provide an em line height for a given symbolic font variant (specified in the theme)
 * @param key the symbolic variant name for the font family. e.g. 'heading', 'sans', etc
 */

export var LINE_HEIGHT = function LINE_HEIGHT(key) {
  return function (props) {
    return prop(props, "lineHeight." + key, 'em');
  };
};
/**
 * Creates a prop function to provide a color for a given symbolic name (specified in the `color` section of theme)
 * @param key the symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 */

export var COLOR = function COLOR(key, fallbackKey) {
  return function (props) {
    return color(props, key, fallbackKey);
  };
};
export var COLORS = function COLORS() {
  var keys = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    keys[_i] = arguments[_i];
  }

  return function (props) {
    return colors.apply(void 0, __spreadArray([props], keys, false));
  };
};
export var FILLS = function FILLS() {
  var keys = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    keys[_i] = arguments[_i];
  }

  return function (props) {
    return fills.apply(void 0, __spreadArray([props], keys, false));
  };
};
/**
 * Creates a prop function to provide a darkened ciolor for a given symbolic name (specified in the `color` section of theme)
 * @param key the symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 */

export var DARKEN = function DARKEN(key, by) {
  return function (props) {
    return darken(props, key, by);
  };
};
/**
 * Creates a prop function to provide a lightened hover color for a given symbolic color key (specified in the `color` section of theme)
 * @param key The symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 * @param lightenBy The decimal percentage to lighten by (as used by the `polished` package)
 */

export var HOVER_COLOR = function HOVER_COLOR(key, lightenBy) {
  if (lightenBy === void 0) {
    lightenBy = 0.2;
  }

  return function (props) {
    return lighten(props, key, lightenBy);
  };
};
/**
 * Creates a prop function to provide a lightened hover color for a given symbolic BACKGROUND color key (specified in the `background` section of theme)
 * @param key The symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 * @param lightenBy The decimal percentage to lighten by (as used by the `polished` package)
 */

export var HOVER_BG = function HOVER_BG(key, lightenBy) {
  if (lightenBy === void 0) {
    lightenBy = 0.1;
  }

  return function (props) {
    return bgLighten(props, key, lightenBy);
  };
};
/**
 * Creates a prop function to provide an svg fill for a given symbolic name (specified in the `color` section of theme)
 * where an "SVG-fill" means to color fill any paths, polygons, shapes descending from the element applied to.
 * @param key the symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 */

export var FILL = function FILL(key, fallbackKey) {
  return function (props) {
    return fill(props, key, fallbackKey);
  };
};
/**
 * Creates a prop function to provide a background color for a given symbolic name (specified in the `background` section of theme)
 * @param key the symbolic variant name for the background color. e.g. 'primary', 'secondary', 'yellow' etc
 */

export var BG = function BG(key) {
  return function (props) {
    return bg(props, key);
  };
};
export var MIN = function MIN(key, unit) {
  if (unit === void 0) {
    unit = 'px';
  }

  return function (props) {
    return prop(props, "dimension.min." + camelCase(key), unit);
  };
};
export var MAX = function MAX(key, unit) {
  if (unit === void 0) {
    unit = 'px';
  }

  return function (props) {
    return prop(props, "dimension.max." + camelCase(key), unit);
  };
};
export var UNIT = function UNIT(multiple, plus) {
  return function (props) {
    return grid(props, multiple, plus || 0);
  };
};
export var GRID_SIZE = function GRID_SIZE(type, size, breakpoint, cssUnit) {
  if (cssUnit === void 0) {
    cssUnit = 'px';
  }

  return function (props) {
    return gridSize(props, type, size, breakpoint, cssUnit);
  };
};
export var CENTER_WITHIN = function CENTER_WITHIN(width, unit) {
  if (unit === void 0) {
    unit = 'px';
  }

  return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  width: 100%;\n  max-width: ", "", ";\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  max-width: ", "", ";\n  margin: 0 auto;\n"])), width, unit);
};
/**
 * Generates a full set of media query rules which vary font sizes based on the breakpoint
 *
 * @param variant The size variant, which allows multiple sets of sizes to be applied to the breakpoints.
 */

export var RESPONSIVE_FONT_SIZE = function RESPONSIVE_FONT_SIZE(variant) {
  if (variant === void 0) {
    variant = 'normal';
  }

  return function (props) {
    return breakpoints({
      base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('base', variant)),
      landscape: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('landscape', variant)),
      tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('tablet', variant)),
      desktop: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('desktop', variant)),
      desktopLarge: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('desktop-large', variant))
    });
  };
};
export var CENTER = function CENTER(direction) {
  if (direction === void 0) {
    direction = 'both';
  }

  return function (props) {
    return css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n"])), (direction === 'both' || direction === 'v') && css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    justify-content: center;\n  "], ["\n    justify-content: center;\n  "]))), (direction === 'both' || direction === 'h') && css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    align-items: center;\n  "], ["\n    align-items: center;\n  "]))));
  };
};
export var REMOVE_BUTTON_STYLE = function REMOVE_BUTTON_STYLE(variant) {
  if (variant === void 0) {
    variant = 'normal';
  }

  return function (props) {
    return css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  padding: 0;\n  outline: none;\n  margin: 0;\n"], ["\n  background: none;\n  border: none;\n  padding: 0;\n  outline: none;\n  margin: 0;\n"])));
  };
};
export var TEXT_ALIGN = function TEXT_ALIGN(justify) {
  return function (props) {
    return JustifyToAlign[justify];
  };
};
export var theme = {
  EXTRA_CSS: EXTRA_CSS,
  DOT_BG: DOT_BG,
  H_DOT_BG: H_DOT_BG,
  V_DOT_BG: V_DOT_BG,
  H_DOT_BG_END: H_DOT_BG_END,
  V_DOT_BG_END: V_DOT_BG_END,
  FONT: FONT,
  FONT_SIZE: FONT_SIZE,
  FONT_SIZE_FOR: FONT_SIZE_FOR,
  LINE_HEIGHT: LINE_HEIGHT,
  COLOR: COLOR,
  COLORS: COLORS,
  DARKEN: DARKEN,
  HOVER_COLOR: HOVER_COLOR,
  HOVER_BG: HOVER_BG,
  FILL: FILL,
  BG: BG,
  MIN: MIN,
  MAX: MAX,
  UNIT: UNIT,
  GRID_SIZE: GRID_SIZE,
  CENTER_WITHIN: CENTER_WITHIN,
  RESPONSIVE_FONT_SIZE: RESPONSIVE_FONT_SIZE,
  CENTER: CENTER,
  REMOVE_BUTTON_STYLE: REMOVE_BUTTON_STYLE,
  TEXT_ALIGN: TEXT_ALIGN
};
export var themes = {
  WEB_THEME: WEB_THEME,
  BIO_THEME: BIO_THEME,
  BLAZE_THEME: BLAZE_THEME,
  HEART_THEME: HEART_THEME,
  JUSTICE_THEME: JUSTICE_THEME,
  LEARN_THEME: LEARN_THEME,
  OCEAN_THEME: OCEAN_THEME,
  OC_THEME: OC_THEME,
  SPORT_THEME: SPORT_THEME,
  TRIBE_THEME: TRIBE_THEME,
  VILLARS_THEME: VILLARS_THEME,
  LAB_THEME: LAB_THEME
};
export { DEFAULT_THEME };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;